import * as Apollo from '@apollo/client';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var ClusterCreatedBy;
(function (ClusterCreatedBy) {
  ClusterCreatedBy["DRAG"] = "drag";
  ClusterCreatedBy["ML"] = "ml";
  ClusterCreatedBy["SPLIT"] = "split";
})(ClusterCreatedBy || (ClusterCreatedBy = {}));
var ClusterSortBy;
(function (ClusterSortBy) {
  ClusterSortBy["DATE"] = "date";
  ClusterSortBy["TITLE"] = "title";
})(ClusterSortBy || (ClusterSortBy = {}));
var ClusterSource;
(function (ClusterSource) {
  ClusterSource["ACTIVITY"] = "activity";
  ClusterSource["CALENDAR"] = "calendar";
  ClusterSource["EMAIL"] = "email";
})(ClusterSource || (ClusterSource = {}));
var DoneApprovalGroupBy;
(function (DoneApprovalGroupBy) {
  DoneApprovalGroupBy["CUSTOMER"] = "customer";
  DoneApprovalGroupBy["EMPLOYEE"] = "employee";
  DoneApprovalGroupBy["PERIOD"] = "period";
  DoneApprovalGroupBy["PROJECT"] = "project";
})(DoneApprovalGroupBy || (DoneApprovalGroupBy = {}));
var NotificationChannel;
(function (NotificationChannel) {
  NotificationChannel["EMAIL"] = "EMAIL";
  NotificationChannel["PUSH"] = "PUSH";
})(NotificationChannel || (NotificationChannel = {}));
var NotificationType;
(function (NotificationType) {
  NotificationType["ERROR"] = "ERROR";
  NotificationType["INFO"] = "INFO";
  NotificationType["PROMOTION"] = "PROMOTION";
  NotificationType["SUCCESS"] = "SUCCESS";
  NotificationType["WARNING"] = "WARNING";
})(NotificationType || (NotificationType = {}));
var PendingApprovalGroupBy;
(function (PendingApprovalGroupBy) {
  PendingApprovalGroupBy["CUSTOMER"] = "customer";
  PendingApprovalGroupBy["EMPLOYEE"] = "employee";
  PendingApprovalGroupBy["PROJECT"] = "project";
})(PendingApprovalGroupBy || (PendingApprovalGroupBy = {}));
var PendingApprovalOrderBy;
(function (PendingApprovalOrderBy) {
  PendingApprovalOrderBy["CUSTOMER"] = "customer";
  PendingApprovalOrderBy["DATE"] = "date";
  PendingApprovalOrderBy["EMPLOYEE"] = "employee";
  PendingApprovalOrderBy["PROJECT"] = "project";
})(PendingApprovalOrderBy || (PendingApprovalOrderBy = {}));
var SortOrder;
(function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
var TenantType;
(function (TenantType) {
  TenantType["MEDC_PRODUCTION"] = "MEDC_production";
  TenantType["SIAP_PRODUCTION"] = "SIAP_production";
  TenantType["CUSTOMER_PRODUCTION"] = "customer_production";
  TenantType["DEBUG"] = "debug";
  TenantType["DEVELOPER"] = "developer";
  TenantType["IMPLEMENTATION"] = "implementation";
  TenantType["OTHER"] = "other";
  TenantType["PARTNER_PRODUCTION"] = "partner_production";
  TenantType["PREVIEW"] = "preview";
  TenantType["SALES_DEMO"] = "sales_demo";
  TenantType["SANDBOX"] = "sandbox";
  TenantType["TEST"] = "test";
})(TenantType || (TenantType = {}));
var TimesheetStatus;
(function (TimesheetStatus) {
  TimesheetStatus["APPROVED"] = "APPROVED";
  TimesheetStatus["DECLINED"] = "DECLINED";
  TimesheetStatus["DRAFT"] = "DRAFT";
  TimesheetStatus["INVOICED"] = "INVOICED";
  TimesheetStatus["PARTIALLY_APPROVED"] = "PARTIALLY_APPROVED";
  TimesheetStatus["PARTIALLY_DECLINED"] = "PARTIALLY_DECLINED";
  TimesheetStatus["SUBMITTED"] = "SUBMITTED";
})(TimesheetStatus || (TimesheetStatus = {}));
var UserRestriction;
(function (UserRestriction) {
  UserRestriction["ANY"] = "ANY";
  UserRestriction["PROJECTS"] = "PROJECTS";
  UserRestriction["PROJECTS_AND_TASKS"] = "PROJECTS_AND_TASKS";
})(UserRestriction || (UserRestriction = {}));
const GetDoneApprovalEntries = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetDoneApprovalEntries"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "companyId"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "ID"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "timesheetId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "orderBy"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "PendingApprovalOrderBy"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageNumber"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageSize"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "doneApprovalEntries"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "companyId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "companyId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "timesheetId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "timesheetId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "orderBy"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "orderBy"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageNumber"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageNumber"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageSize"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageSize"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "count"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "timesheet"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "description"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "startDate"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "endDate"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "status"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalBillableHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalNonBillableHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "employeeName"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "groups"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "results"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "date"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "description"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "notes"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "status"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "billable"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "nextApprovers"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "declineAllowed"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "approvals"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "id"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approvalStage"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approvalType"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approvedBy"
                        },
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            }
                          }, {
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "name"
                            }
                          }]
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approver"
                        },
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            }
                          }, {
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "name"
                            }
                          }]
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "comments"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "eventDate"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "status"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "client"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "project"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "task"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "item"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "timeType"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "dimensions"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "dimension"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "objectName"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
const GetDoneApprovalGroups = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetDoneApprovalGroups"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "groupBy"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "DoneApprovalGroupBy"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageNumber"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageSize"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "search"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "doneApprovalGroups"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "groupBy"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "groupBy"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageNumber"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageNumber"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageSize"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageSize"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "search"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "search"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "count"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "results"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "externalId"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalBillableHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalNonBillableHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "rows"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "employeeName"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "startDate"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "endDate"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalNonBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalTimesheetHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalTimesheetBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalTimesheetNonBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "description"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "status"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "entries"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "nextApprovers"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
const GetPendingApprovalEntries = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetPendingApprovalEntries"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "companyId"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "ID"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "groupBy"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "PendingApprovalGroupBy"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "groupId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "orderBy"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "PendingApprovalOrderBy"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageNumber"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageSize"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "pendingApprovalEntries"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "companyId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "companyId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "groupBy"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "groupBy"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "groupId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "groupId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "orderBy"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "orderBy"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageNumber"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageNumber"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageSize"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageSize"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "count"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "groups"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "totalHours"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "results"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "date"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "description"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "notes"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "status"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "billable"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "nextApprovers"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "isProcessing"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "approvals"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "id"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approvalStage"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approvalType"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approvedBy"
                        },
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            }
                          }, {
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "name"
                            }
                          }]
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "approver"
                        },
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            }
                          }, {
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "name"
                            }
                          }]
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "comments"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "eventDate"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "status"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "client"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "project"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "task"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "item"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "timeType"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "dimensions"
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "dimension"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "externalId"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        }
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "objectName"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
const GetPendingApprovalGroups = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetPendingApprovalGroups"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "companyId"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "ID"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "groupBy"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "PendingApprovalGroupBy"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageNumber"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageSize"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "search"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "pendingApprovalGroups"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "companyId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "companyId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "groupBy"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "groupBy"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageNumber"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageNumber"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageSize"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageSize"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "search"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "search"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "count"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "groups"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "results"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "externalId"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "startDate"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "endDate"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalNonBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "description"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "status"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "customerExternalId"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "customerName"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
const GetPendingApprovalSelected = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetPendingApprovalSelected"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "companyId"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "ID"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "groupIds"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "ListType",
          "type": {
            "kind": "NamedType",
            "name": {
              "kind": "Name",
              "value": "ID"
            }
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "groupBy"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "PendingApprovalGroupBy"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageNumber"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "pageSize"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "pendingApprovalSelected"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "companyId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "companyId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "groupIds"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "groupIds"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "groupBy"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "groupBy"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageNumber"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageNumber"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "pageSize"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "pageSize"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "count"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "groups"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "rows"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "rowId"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "title"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "employeeId"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "startDate"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "endDate"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "totalNonBillableHours"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "status"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "entries"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
const FetchNotifications = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "FetchNotifications"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "notifications"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "input"
          },
          "value": {
            "kind": "ObjectValue",
            "fields": [{
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "channel"
              },
              "value": {
                "kind": "EnumValue",
                "value": "PUSH"
              }
            }]
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "type"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notification"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "body"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "timestamp"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "meta"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "pushIsRead"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "metaId"
            }
          }]
        }
      }]
    }
  }]
};
const ReadNotifications = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "ReadNotifications"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "readAllNotifications"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notifications"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "notification"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "title"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "body"
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "timestamp"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "meta"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "metaId"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "pushIsRead"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
const OnNewNotification = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "subscription",
    "name": {
      "kind": "Name",
      "value": "OnNewNotification"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "newNotification"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "type"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notification"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "body"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "topic"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "data"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "timestamp"
            }
          }]
        }
      }]
    }
  }]
};

const defaultOptions = {};
/**
 * __useGetDoneApprovalEntriesQuery__
 *
 * To run a query within a React component, call `useGetDoneApprovalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoneApprovalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoneApprovalEntriesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      timesheetId: // value for 'timesheetId'
 *      orderBy: // value for 'orderBy'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
function useGetDoneApprovalEntriesQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useQuery(GetDoneApprovalEntries, options);
}
function useGetDoneApprovalEntriesLazyQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useLazyQuery(GetDoneApprovalEntries, options);
}
/**
 * __useGetDoneApprovalGroupsQuery__
 *
 * To run a query within a React component, call `useGetDoneApprovalGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoneApprovalGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoneApprovalGroupsQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
function useGetDoneApprovalGroupsQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useQuery(GetDoneApprovalGroups, options);
}
function useGetDoneApprovalGroupsLazyQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useLazyQuery(GetDoneApprovalGroups, options);
}
/**
 * __useGetPendingApprovalEntriesQuery__
 *
 * To run a query within a React component, call `useGetPendingApprovalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingApprovalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingApprovalEntriesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      groupBy: // value for 'groupBy'
 *      groupId: // value for 'groupId'
 *      orderBy: // value for 'orderBy'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
function useGetPendingApprovalEntriesQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useQuery(GetPendingApprovalEntries, options);
}
function useGetPendingApprovalEntriesLazyQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useLazyQuery(GetPendingApprovalEntries, options);
}
/**
 * __useGetPendingApprovalGroupsQuery__
 *
 * To run a query within a React component, call `useGetPendingApprovalGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingApprovalGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingApprovalGroupsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      groupBy: // value for 'groupBy'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
function useGetPendingApprovalGroupsQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useQuery(GetPendingApprovalGroups, options);
}
function useGetPendingApprovalGroupsLazyQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useLazyQuery(GetPendingApprovalGroups, options);
}
/**
 * __useGetPendingApprovalSelectedQuery__
 *
 * To run a query within a React component, call `useGetPendingApprovalSelectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingApprovalSelectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingApprovalSelectedQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      groupIds: // value for 'groupIds'
 *      groupBy: // value for 'groupBy'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
function useGetPendingApprovalSelectedQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useQuery(GetPendingApprovalSelected, options);
}
function useGetPendingApprovalSelectedLazyQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useLazyQuery(GetPendingApprovalSelected, options);
}
/**
 * __useFetchNotificationsQuery__
 *
 * To run a query within a React component, call `useFetchNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
function useFetchNotificationsQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useQuery(FetchNotifications, options);
}
function useFetchNotificationsLazyQuery(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useLazyQuery(FetchNotifications, options);
}
/**
 * __useReadNotificationsMutation__
 *
 * To run a mutation, you first call `useReadNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationsMutation, { data, loading, error }] = useReadNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
function useReadNotificationsMutation(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useMutation(ReadNotifications, options);
}
/**
 * __useOnNewNotificationSubscription__
 *
 * To run a query within a React component, call `useOnNewNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
function useOnNewNotificationSubscription(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useSubscription(OnNewNotification, options);
}

export { ClusterCreatedBy, ClusterSortBy, ClusterSource, DoneApprovalGroupBy, FetchNotifications, GetDoneApprovalEntries, GetDoneApprovalGroups, GetPendingApprovalEntries, GetPendingApprovalGroups, GetPendingApprovalSelected, NotificationChannel, NotificationType, OnNewNotification, PendingApprovalGroupBy, PendingApprovalOrderBy, ReadNotifications, SortOrder, TenantType, TimesheetStatus, UserRestriction, useFetchNotificationsLazyQuery, useFetchNotificationsQuery, useGetDoneApprovalEntriesLazyQuery, useGetDoneApprovalEntriesQuery, useGetDoneApprovalGroupsLazyQuery, useGetDoneApprovalGroupsQuery, useGetPendingApprovalEntriesLazyQuery, useGetPendingApprovalEntriesQuery, useGetPendingApprovalGroupsLazyQuery, useGetPendingApprovalGroupsQuery, useGetPendingApprovalSelectedLazyQuery, useGetPendingApprovalSelectedQuery, useOnNewNotificationSubscription, useReadNotificationsMutation };
//# sourceMappingURL=index.modern.js.map
